import Vue from 'vue'
import Router from 'vue-router'
import auth from '@/auth/authService'

import firebase from 'firebase/app'
import 'firebase/auth'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [

    {
    // =============================================================================
    // MAIN LAYOUT ROUTES || >>> EVOLUGY Dashboard COMPONENTS <<<
    // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Dashboard Routes
        // =============================================================================
        {
          path: '/',
          redirect: '/dashboard/d'
        },
        {
          path: '/dashboard/d',
          name: 'dashboard-doc',
          component: () => import('./views/DashboardDoc.vue'),
          meta: {
            rule: 'editor',
            authRequired:true,
          }
        },
        {
          path: '/dashboard/s',
          name: 'dashboard-sec',
          component: () => import('./views/DashboardSec.vue'),
          meta: {
            rule: 'editor'
          }
        },
        // =============================================================================
        // Consultation Routes
        // =============================================================================
        {
          path: '/consultations/newConsultation',
          name: 'contulations-new',
          component: () => import('./views/consultations/consultation/ConsultationForm.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/consultations/signosvitales',
          name: 'signos-vitales',
          component: () => import('./views/consultations/consultation/SignosVitales.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/consultations/upcommingAppointments',
          name: 'contulations-upcommingAppointments',
          component: () => import('./views/consultations/upcomming.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'Consultas' },
              { title: 'Próximas Consultas', active: true }
            ],
            pageTitle: 'Próximas Consultas',
            rule: 'editor'
          }
        },
        {
          path: '/consultations/calendar',
          name: 'contulations-calendar',
          component: () => import('./views/calendars/Calendar.vue'),
          meta: {
            isCalendar: true,
            pageTitle: 'Calendario',
            rule: 'editor'
          }
        },
        {
          path: '/consultations/history',
          name: 'contulations-history',
          component: () => import('./views/consultations/consultationsList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'Consultas' },
              { title: 'Historial', active: true }
            ],
            pageTitle: 'Historial de Consultas',
            rule: 'editor'
          }
        },
        // =============================================================================
        // Patients Routes
        // =============================================================================
        {
          path: '/patients/list',
          name: 'patients-list',
          component: () => import('./views/patients/user-list/PatientsList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'Pacientes' },
              { title: 'Lista', active: true }
            ],
            pageTitle: 'Lista de Pacientes',
            rule: 'editor'
          }
        },
        {
          path: '/patients/patient/view/:userId',
          name: 'patient-view',
          component: () => import('./views/patients/patient/PatientView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'Pacientes' },
              { title: 'Ficha', active: true }
            ],
            pageTitle: 'Ficha de Paciente',
            rule: 'editor'
          },
        },
        
        // =============================================================================
        // Recipes Routes
        // =============================================================================
        {
          path: '/recipes/recipe/view/:recipe_id',
          name: 'recipes-new',
          component: () => import('./views/recipes/RecipeView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'Recetas' },
              { title: 'Receta', active: true }
            ],
            pageTitle: 'Receta',
            rule: 'editor'
          }
        },
        {
          path: '/recipes/list',
          name: 'recipes-list',
          component: () => import('./views/recipes/RecipesList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'Recetas' },
              { title: 'Lista de recetas', active: true }
            ],
            pageTitle: 'Lista de recetas',
            rule: 'editor'
          }
        },
        {
          path: '/recipes/exams',
          name: 'recipes-exams',
          component: () => import('./views/recipes/ExamsList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'Recetas' },
              { title: 'Lista de exámenes', active: true }
            ],
            pageTitle: 'Lista de exámenes',
            rule: 'editor'
          }
        },
        {
          path: '/recipes/exam/view/:exam_id',
          name: 'View Recipe',
          component: () => import('./views/recipes/ExamView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'Exámenes' },
              { title: 'Examen', active: true }
            ],
            pageTitle: 'Examen',
            rule: 'editor'
          }
        },
        // =============================================================================
        // Reports Routes
        // =============================================================================
        {
          path: '/reports',
          name: 'reports',
          component: () => import('./views/ui-elements/ag-grid-table/AgGridTable.vue'),
          meta: {
            rule: 'editor'
          }
        },
        // =============================================================================
        // Box Routes
        // =============================================================================
        {
          path: '/box',
          name: 'Caja',
          component: () => import('./views/box/transactions-list/TransactionsList.vue'),
          meta: {
            rule: 'editor'
          }
        },
        // =============================================================================
        // Profile Routes
        // =============================================================================
        {
          path: '/profile/myAccount',
          name: 'profile-myAccount',
          component: () => import('./views/profile/Profile.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'Perfil' },
              { title: 'Mi Cuenta', active: true }
            ],
            pageTitle: 'Mi Cuenta',
            rule: 'editor'
          }
        },
        {
          path: '/profile/myTeam',
          name: 'profile-myTeam',
          component: () => import('./views/DashboardAnalytics.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/profile/settings',
          name: 'profile-settings',
          component: () => import('./views/pages/user-settings/UserSettings.vue'),
          meta: {
            breadcrumb: [
              { title: 'Dashboard', url: '/' },
              { title: 'Perfil', url: '/profile/myAccount' },
              { title: 'Ajustes', active: true }
            ],
            pageTitle: 'Mi Cuenta',
            rule: 'editor'
          }
        },
        // =============================================================================
        // Support Routes
        // =============================================================================
        {
          path: '/support/documentation',
          name: 'support-documentation',
          component: () => import('./views/pages/FaqEvolugy.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/support/raise',
          name: 'support-raise',
          component: () => import('./views/pages/RaiseSupport.vue'),
          meta: {
            rule: 'editor'
          }
        }
      ]
    },
    
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/callback',
          name: 'auth-callback',
          component: () => import('@/views/Callback.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/login',
          name: 'page-login',
          component: () => import('@/views/pages/login/Login.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/register',
          name: 'page-register',
          component: () => import('@/views/pages/register/Register.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/forgot-password',
          name: 'page-forgot-password',
          component: () => import('@/views/pages/ForgotPassword.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/reset-password',
          name: 'page-reset-password',
          component: () => import('@/views/pages/ResetPassword.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/patient/terms-cond',
          name: 'terms-cond',
          component: () => import('@/views/pages/TermsCondP.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/doctor/terms-cond',
          name: 'terms-cond',
          component: () => import('@/views/pages/TermsCondD.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/comingsoon',
          name: 'page-coming-soon',
          component: () => import('@/views/pages/ComingSoon.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/error-500',
          name: 'page-error-500',
          component: () => import('@/views/pages/Error500.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/not-authorized',
          name: 'page-not-authorized',
          component: () => import('@/views/pages/NotAuthorized.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/maintenance',
          name: 'page-maintenance',
          component: () => import('@/views/pages/Maintenance.vue'),
          meta: {
            rule: 'editor'
          }
        },
        // =============================================================================
        // Custom link Routes
        // =============================================================================
        {
          path: '/links/new-patient-consultation',
          name: 'Nuevo Paciente Nueva Consulta',
          component: () => import('./views/forms/custom-links/newPatientConsultation.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/links/new-patient-confirm/:event_id',
          name: 'Nuevo Paciente Confirmacion',
          component: () => import('./views/forms/custom-links/newPatientConfirm.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/links/consultation/:event_id',
          name: 'Nuevo Paciente Confirmacion',
          component: () => import('./views/forms/custom-links/consultationLink.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/links/confirm-hook/:event_id',
          name: 'Confirmacion de Consulta',
          component: () => import('./views/forms/custom-links/consultationConfirmHook.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/links/confirm-s',
          name: 'Nuevo Paciente Confirmacion Exitosa',
          component: () => import('./views/forms/custom-links/confirmSuccess.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/links/confirm-an',
          name: 'Anulación Éxitosa',
          component: () => import('./views/forms/custom-links/confirmAnSuccess.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/links/confirm-ed',
          name: 'Edición Éxitosa',
          component: () => import('./views/forms/custom-links/confirmEditSuccess.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/links/confirm-p',
          name: 'Nuevo Registro de Paciente Exitoso',
          component: () => import('./views/forms/custom-links/confirmSuccessP.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/links/confirm-r',
          name: 'Nuevo de Calificación Éxitosa',
          component: () => import('./views/forms/custom-links/confirmSuccessR.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/links/confirm-sec',
          name: 'Nuevo de Calificación Éxitosa',
          component: () => import('./views/forms/custom-links/confirmSuccessSec.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/links/new-patient/:doctor_id',
          name: 'Nuevo Paciente',
          component: () => import('./views/forms/custom-links/newPatient.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/links/consultation-request/:user_id/:doctor_id',
          name: 'Nueva consulta',
          component: () => import('./views/forms/custom-links/newConsultation.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/links/consultation-review/:consultation_id',
          name: 'Reseña',
          component: () => import('./views/forms/custom-links/consultationReview.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/links/recipe/view/:doctor_id/:recipe_id',
          name: 'Public Recipe',
          component: () => import('./views/forms/custom-links/RecipeView.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/links/exam/view/:doctor_id/:exam_id',
          name: 'Public Exam',
          component: () => import('./views/forms/custom-links/ExamView.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/auth/zoom-redirect',
          name: 'Zoom',
          component: () => import('./views/auth/zoomRedirect.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/links/new-secretary/:secretary_id',
          name: 'Zoom',
          component: () => import('./views/forms/custom-links/newSecretary.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
        path: '/links/external/:doctor_id',
        name: 'Registro Paciente',
        component: () => import('./views/forms/custom-links/newPatientMedico.vue'),
        meta: {
          rule: 'editor'
        }
        }             
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach((to, from, next) => {
  firebase.auth().onAuthStateChanged(() => {

    // get firebase current user
    const firebaseCurrentUser = firebase.auth().currentUser

    // if (
    //     to.path === "/pages/login" ||
    //     to.path === "/pages/forgot-password" ||
    //     to.path === "/pages/error-404" ||
    //     to.path === "/pages/error-500" ||
    //     to.path === "/pages/register" ||
    //     to.path === "/callback" ||
    //     to.path === "/pages/comingsoon" ||
    //     (auth.isAuthenticated() || firebaseCurrentUser)
    // ) {
    //     return next();
    // }

    // If auth required, check login. If login fails redirect to login page
    if (to.meta.authRequired) {
      if (!(auth.isAuthenticated() || firebaseCurrentUser)) {
        router.push({ path: '/pages/login', query: { to: to.path } })
      }
    }

    return next()
    // Specify the current path as the customState parameter, meaning it
    // will be returned to the application after auth
    // auth.login({ target: to.path });

  })

})

export default router
